document.addEventListener("DOMContentLoaded", function() {
  // Remove any previous event listeners to prevent double counting
  window.removeEventListener('scroll', checkCounters);
  
  const counters = document.querySelectorAll('.value');
  const speed = 200;
  
  // Set initial values to 0
  counters.forEach(counter => {
    counter.innerText = '0';
  });
  
  // Track which counters have been animated
  const animatedCounters = new Set();
  
  // Function to format numbers consistently
  function formatNumber(num) {
    // Use locale-aware formatting with thousands separators
    return num.toLocaleString('en-US');
  }
  
  // Function to check if element is in viewport
  function isInViewport(element) {
    const rect = element.getBoundingClientRect();
    const windowHeight = window.innerHeight || document.documentElement.clientHeight;
    return (
      (rect.top <= windowHeight * 0.8 && rect.bottom >= windowHeight * 0.2) ||
      (rect.top >= 0 && rect.top <= windowHeight * 0.8)
    );
  }
  
  // Function to animate counter
  function animateCounter(counter) {
    if (animatedCounters.has(counter)) return; // Skip if already animated
    
    const value = +counter.getAttribute('count');
    let current = 0;
    
    const increment = Math.ceil(value / 30); // More steps for smoother animation
    const timer = setInterval(() => {
      current += increment;
      if (current >= value) {
        current = value;
        clearInterval(timer);
      }
      // Apply consistent formatting
      counter.innerText = formatNumber(current);
    }, 40);
    
    // Mark as animated
    animatedCounters.add(counter);
  }
  
  // Function to check all counters
  function checkCounters() {
    counters.forEach(counter => {
      if (isInViewport(counter) && !animatedCounters.has(counter)) {
        animateCounter(counter);
      }
    });
  }
  
  // Initial check
  checkCounters();
  
  // Add scroll event with throttling to improve performance
  let scrollTimeout;
  window.addEventListener('scroll', function() {
    if (scrollTimeout) {
      clearTimeout(scrollTimeout);
    }
    scrollTimeout = setTimeout(checkCounters, 100);
  });
});